import { render, staticRenderFns } from "./InvestmentTransactionView.vue?vue&type=template&id=0f0a3945"
import script from "./InvestmentTransactionView.vue?vue&type=script&lang=ts"
export * from "./InvestmentTransactionView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports